export default "__VITE_ASSET__8285caf2__"